"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var search_bar_component_1 = require("./search-bar.component");
Object.defineProperty(exports, "SearchBar", { enumerable: true, get: function () { return search_bar_component_1.SearchBar; } });
